// extracted by mini-css-extract-plugin
module.exports = {"aside":"style_aside__3CIoR","row":"style_row__1pOwh"};